var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 73,
    viewBox: "0 0 29 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1358 1.07007C26.3636 1.07007 26.5751 1.12709 26.7703 1.24113C26.9655 1.35518 27.1445 1.52624 27.3072 1.75433C27.6325 2.21051 27.7952 2.76932 27.7952 3.43077C27.7952 4.09223 27.6325 4.65104 27.3072 5.10721L5.05101 36.3096L27.0143 67.1013C27.3397 67.5575 27.5024 68.1049 27.5024 68.7436C27.5024 69.3822 27.3397 69.9296 27.0143 70.3858C26.6889 70.842 26.2903 71.0701 25.8185 71.0701C25.3467 71.0701 24.9481 70.842 24.6228 70.3858L1.48807 37.9518C1.16269 37.4956 1 36.9482 1 36.3096C1 35.6709 1.16269 35.1235 1.48807 34.6673L24.9644 1.75433C25.1271 1.52624 25.3142 1.35518 25.5257 1.24113C25.7372 1.12709 25.9406 1.07007 26.1358 1.07007Z",
    fill: "#74F5A8",
    stroke: "#3B9860",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.2c5472b5.svg";
export { ForwardRef as ReactComponent };